<template>
  <Content class="food-type-page">
    <Card>
      <div slot="title">商品分类</div>
      <p class="page-tip">配置小程序点餐页左侧分类；排序数字越小越靠前，「隐藏」的分类不会在小程序展示。</p>
      <Form id="foodTypeSearchForm" :model="formItem" :label-width="80" inline>
        <FormItem label="分类名称">
          <Input v-model="formItem.key" placeholder="模糊搜索" clearable style="width: 180px" />
        </FormItem>
        <FormItem label="状态">
          <Select v-model="formItem.status" clearable placeholder="全部" style="width: 120px">
            <Option value="">全部</Option>
            <Option value="up">展示</Option>
            <Option value="down">隐藏</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="20">
          <Button type="primary" @click="search">查询</Button>
          <Button style="margin-left: 8px" @click="clear">重置</Button>
        </FormItem>
        <FormItem class="action-buttons-right">
          <Button type="primary" icon="ios-add" @click="show()">添加分类</Button>
        </FormItem>
      </Form>
      <Table :columns="columns" :data="tableData" :height="tablesHeight" border />
      <Page
        v-show="total"
        class="table_page_css"
        :total="total"
        :current="searchInfo.pageNo"
        :page-size="searchInfo.pageSize"
        :page-size-opts="pageSizeOpts"
        show-sizer
        show-elevator
        show-total
        @on-change="pageNoChange"
        @on-page-size-change="pageSizeChange"
      />
    </Card>
    <AddUpdate ref="AddUpdate" @reload="getList" />
  </Content>
</template>

<script>
import { foodTypePage, foodTypeDel } from '@/api/foodType'
import AddUpdate from './FoodTypeAddUpdate'

export default {
  name: 'FoodTypeManage',
  components: { AddUpdate },
  data() {
    return {
      columns: [
        { title: 'ID', key: 'type_id', width: 80, align: 'center' },
        { title: '分类名称', key: 'name', minWidth: 140 },
        { title: '排序', key: 'sort', width: 90, align: 'center' },
        {
          title: '状态',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, { row }) => {
            const up = (row.status || 'up') === 'up'
            return h('Tag', { props: { color: up ? 'success' : 'default' } }, up ? '展示' : '隐藏')
          },
        },
        {
          title: '操作',
          key: 'action',
          width: 160,
          align: 'center',
          render: (h, { row }) =>
            h('div', [
              h(
                'Button',
                {
                  props: { type: 'primary', size: 'small' },
                  style: { marginRight: '5px' },
                  on: { click: () => this.show(row) },
                },
                '编辑'
              ),
              h(
                'Poptip',
                {
                  props: { confirm: true, transfer: true, title: '确认删除该分类？' },
                  on: {
                    'on-ok': () => this.remove(row),
                  },
                },
                [h('Button', { props: { type: 'error', size: 'small' } }, '删除')]
              ),
            ]),
        },
      ],
      tableData: [],
      total: 0,
      searchInfo: { pageNo: 1, pageSize: 10 },
      pageSizeOpts: [10, 20, 50],
      formItem: { key: '', status: '' },
      tablesHeight: 400,
    }
  },
  mounted() {
    this.getList()
    this.$nextTick(() => this.setTablesHeight())
    window.addEventListener('resize', this.setTablesHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setTablesHeight)
  },
  methods: {
    setTablesHeight() {
      try {
        const oA = document.getElementById('app')
        const sA = document.getElementById('foodTypeSearchForm')
        if (!oA) return
        const oH = oA.clientHeight || oA.offsetHeight
        const sH = sA ? sA.clientHeight || sA.offsetHeight : 0
        this.tablesHeight = Math.max(320, oH - sH - 300)
      } catch (e) {
        this.tablesHeight = 400
      }
    },
    getList() {
      foodTypePage({
        ...this.searchInfo,
        key: this.formItem.key,
        status: this.formItem.status || undefined,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.tableData = (res.data.data || []).map((row) => ({
              ...row,
              type_id: row.type_id != null ? row.type_id : row.typeid,
            }))
            this.total = res.data.total || 0
          } else {
            this.$Message.error(res.data.msg || '加载失败')
          }
        })
        .catch((err) => this.$Message.error(err.message || '加载失败'))
    },
    search() {
      this.searchInfo.pageNo = 1
      this.getList()
    },
    clear() {
      this.formItem = { key: '', status: '' }
      this.searchInfo = { pageNo: 1, pageSize: this.searchInfo.pageSize }
      this.getList()
    },
    pageNoChange(n) {
      this.searchInfo.pageNo = n
      this.getList()
    },
    pageSizeChange(n) {
      this.searchInfo.pageSize = n
      this.searchInfo.pageNo = 1
      this.getList()
    },
    show(row) {
      this.$refs.AddUpdate.init(row || null)
    },
    remove(row) {
      const type_id = row.type_id != null ? row.type_id : row.typeid
      foodTypeDel({ type_id })
        .then((res) => {
          if (res.data.code === 200) {
            this.$Message.success('删除成功')
            this.getList()
          } else {
            this.$Message.error(res.data.msg || '删除失败')
          }
        })
        .catch((err) => this.$Message.error(err.message || '删除失败'))
    },
  },
}
</script>

<style scoped>
.page-tip {
  color: #909399;
  font-size: 13px;
  margin: 0 0 16px;
  line-height: 1.5;
}
</style>
